import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getAllLinkPaymentStatus = () => get(url.LINK_PAYMENT_STATUS_GET)
